import { TableData } from '@/components/TableData/TableData';
import TableLayout from '@/layouts/TableLayout/TableLayout';
import { useNavigate } from 'react-router-dom';
import { Filters } from './Filters/Filters';
import { useOrdersDetailViewController } from './OrdersDetailViewController';
import { itemGenerator } from './TableItem';

export function OrdersDetailContainer(props: { onlyPendingOrders?: boolean }) {
  const { uiState, actions } = useOrdersDetailViewController();
  const navigate = useNavigate();

  return (
    <TableLayout
      isLoading={uiState.isLoading}
      header={<Filters onlyPendingOrders={props.onlyPendingOrders} />}
      body={
        <>
          <TableData
            columnHeaders={uiState.columnHeaders}
            items={uiState.items}
            rowItemGenerator={itemGenerator}
            paging={uiState.paging}
            onPageSelected={actions.onPageRequested}
            roundedTop={true}
            compact={true}
            onRowClick={(item) => {
              navigate(`/admin/orders/detail/${item.orderId}`);
            }}
          />
        </>
      }
    />
  );
}
